import { api } from '../../plugins/api';

const getDefaultState = () => {
  return {
  }
}

const state = getDefaultState()

const getters = {
}

const mutations = {
  resetState (state) {
    Object.assign(state, getDefaultState())
  }
}

const actions = {
  async getOrganisationByLabel ({ commit }, pLabel) {
    let response = await api.get(`organisations?label=` + pLabel);
    return response.data;
  },
  async getOrganisation ({ commit }, id) {
    let response = await api.get(`organisations/` + id);
    return response.data;
  },
  async createOrganisation ({ commit }, organisation) {
    let response = await api.post(`organisations`, organisation);
    return response.data 
  },
  resetModuleState ({ commit }) {
    commit('resetState')
  },
}

export default ({
  namespaced: true,
  state: state,
  mutations: mutations,
  getters: getters,
  actions: actions
})
